"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMAND_STYLE_TROPICAL_DEFAULTS = exports.COMMAND_STYLE_STREET_DEFAULTS = exports.COMMAND_STYLE_PRESTIGE_DEFAULTS = exports.COMMAND_STYLE_PIZZA_DEFAULTS = exports.COMMAND_STYLE_PATISSERIE_DEFAULTS = exports.COMMAND_STYLE_NEON_DEFAULTS = exports.COMMAND_STYLE_MODERN_DEFAULTS = exports.COMMAND_STYLE_MINIMAL_DEFAULTS = exports.COMMAND_STYLE_LATINO_DEFAULTS = exports.COMMAND_STYLE_DEMO_DEFAULTS = exports.COMMAND_STYLE_DEFAULTS = void 0;
exports.buildCommandKioskStyle = buildCommandKioskStyle;
exports.getCommandLabels = getCommandLabels;
exports.getTemplateStyleDefaults = getTemplateStyleDefaults;
exports.mergeCommandStyles = mergeCommandStyles;
const CSS_VAR_MAP = {
  background_color: '--kiosk-bg',
  surface_color: '--kiosk-surface',
  card_color: '--kiosk-card',
  accent_color: '--kiosk-accent',
  accent_hover_color: '--kiosk-accent-hover',
  accent_dim_color: '--kiosk-accent-dim',
  text_color: '--kiosk-text',
  text_muted_color: '--kiosk-text-muted',
  border_color: '--kiosk-border',
  highlight_color: '--kiosk-highlight'
};
const DEFAULT_LABELS = {
  consumption_title: 'Comment souhaitez-vous déguster ?',
  on_site_label: 'Sur place',
  takeaway_label: 'À emporter',
  products_title: 'Commandez',
  cart_title: 'Votre commande',
  add_to_cart_label: 'Ajouter',
  details_label: 'Plus de détails',
  all_products_tab: 'Tous',
  popular_badge: 'Populaire',
  validate_order_prefix: 'Valider la commande',
  recap_title: 'Récapitulatif',
  qr_code_title: 'Scannez le QR code pour payer',
  payment_success_title: 'Paiement accepté',
  payment_success_message: 'Votre commande est enregistrée (carte sur le terminal). Présentez-vous au comptoir si besoin.',
  new_order_label: 'Nouvelle commande',
  total_prefix: 'Total'
};
const TEMPLATE_LABEL_OVERRIDES = {
  pizza: {
    consumption_title: 'Où souhaitez-vous déguster ?',
    on_site_label: 'En salle',
    takeaway_label: 'À emporter',
    products_title: 'Nos pizzas',
    cart_title: 'Votre commande',
    add_to_cart_label: 'Ajouter 🍕',
    popular_badge: 'Best-seller',
    validate_order_prefix: 'Commander',
    recap_title: 'Il tuo ordine',
    qr_code_title: 'Scannez pour payer',
    new_order_label: 'Nuova ordinazione'
  },
  tropical: {
    consumption_title: 'Comment profitez-vous du paradis ?',
    on_site_label: 'Sur la terrasse',
    takeaway_label: 'Plage & emporté',
    products_title: 'Paradise Menu',
    cart_title: 'Votre panier tropical',
    add_to_cart_label: 'Ajouter 🌴',
    popular_badge: 'Coup de soleil',
    validate_order_prefix: 'Valider au comptoir',
    recap_title: 'Récap sous les palmiers',
    qr_code_title: 'Scannez et détendez-vous',
    new_order_label: 'Nouvelle escapade'
  },
  street: {
    consumption_title: 'Tu manges où ?',
    on_site_label: 'Sur le comptoir',
    takeaway_label: 'À emporter',
    products_title: 'La carte street',
    cart_title: 'Ton panier',
    add_to_cart_label: 'Ajouter 🔥',
    popular_badge: 'Hot',
    validate_order_prefix: 'Commander',
    recap_title: 'Récap de commande',
    new_order_label: 'Recommencer'
  },
  patisserie: {
    consumption_title: 'Où savourerez-vous ?',
    on_site_label: 'En salon de thé',
    takeaway_label: 'À emporter',
    products_title: 'Nos douceurs',
    cart_title: 'Votre sélection',
    add_to_cart_label: 'Ajouter 🧁',
    popular_badge: 'Coup de cœur',
    validate_order_prefix: 'Valider la commande',
    recap_title: 'Votre panier gourmand',
    new_order_label: 'Nouvelle pause sucrée'
  },
  prestige: {
    consumption_title: 'Comment souhaitez-vous être servi ?',
    on_site_label: 'En salle',
    takeaway_label: 'À emporter',
    products_title: 'La carte',
    cart_title: 'Votre sélection',
    add_to_cart_label: 'Sélectionner',
    popular_badge: 'Signature',
    validate_order_prefix: 'Confirmer',
    recap_title: 'Récapitulatif',
    qr_code_title: 'Finalisez votre règlement',
    new_order_label: 'Nouvelle expérience'
  },
  neon: {
    consumption_title: 'Choisis ton mode de jeu',
    on_site_label: 'Sur place',
    takeaway_label: 'Take away',
    products_title: 'Le menu arcade',
    cart_title: 'Inventaire',
    add_to_cart_label: 'Loot +1',
    popular_badge: 'Legendary',
    validate_order_prefix: 'Start',
    recap_title: 'Score final',
    qr_code_title: 'Scanne pour payer',
    new_order_label: 'New game'
  },
  minimal: {
    consumption_title: 'Mode de consommation',
    on_site_label: 'Sur place',
    takeaway_label: 'À emporter',
    products_title: 'Menu',
    cart_title: 'Panier',
    add_to_cart_label: 'Ajouter',
    popular_badge: 'Recommandé',
    validate_order_prefix: 'Valider',
    recap_title: 'Récapitulatif',
    new_order_label: 'Nouvelle commande'
  },
  latino: {
    consumption_title: 'Où est-ce qu’on s’installe ?',
    on_site_label: 'À table',
    takeaway_label: 'À emporter',
    products_title: 'La carta',
    cart_title: 'Votre pedido',
    add_to_cart_label: 'Ajouter',
    all_products_tab: 'Tout',
    popular_badge: 'Especial',
    validate_order_prefix: 'Valider',
    recap_title: 'Récapitulatif',
    qr_code_title: 'Scannez pour régler',
    payment_success_title: '¡Listo !',
    payment_success_message: 'Votre commande est enregistrée. Buen provecho.',
    new_order_label: 'Nouvelle commande'
  },
  demo: {
    consumption_title: 'Comment souhaitez-vous continuer ?',
    on_site_label: 'Sur place',
    takeaway_label: 'À emporter',
    products_title: 'Sélection',
    cart_title: 'Votre sélection',
    add_to_cart_label: 'Ajouter',
    all_products_tab: 'Tout',
    popular_badge: 'À la une',
    validate_order_prefix: 'Continuer',
    recap_title: 'Récapitulatif',
    qr_code_title: 'Finalisez votre paiement',
    payment_success_title: 'C’est confirmé',
    payment_success_message: 'Votre commande est enregistrée. Merci.',
    new_order_label: 'Recommencer',
    total_prefix: 'Total'
  }
};
function hexToRgba(hex, alpha) {
  if (!hex || typeof hex !== 'string') return undefined;
  const normalized = hex.replace('#', '');
  if (normalized.length !== 3 && normalized.length !== 6) return undefined;
  const full = normalized.length === 3 ? normalized.split('').map(c => c + c).join('') : normalized;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return undefined;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
function getCommandLabels(styles_properties = {}, templateVariant = 'default') {
  const baseLabels = {
    ...DEFAULT_LABELS,
    ...(TEMPLATE_LABEL_OVERRIDES[templateVariant] || {})
  };
  return {
    ...baseLabels,
    ...Object.fromEntries(Object.entries(styles_properties).filter(([key, value]) => key in DEFAULT_LABELS && typeof value === 'string' && value.trim()))
  };
}
function buildCommandKioskStyle(styles_properties = {}, scaleFactor = 1, extraStyle = {}) {
  const cssVars = {};
  for (const [propKey, cssVar] of Object.entries(CSS_VAR_MAP)) {
    const value = styles_properties[propKey];
    if (value != null && value !== '') {
      cssVars[cssVar] = value;
    }
  }
  if (!cssVars['--kiosk-accent-dim'] && styles_properties.accent_color) {
    const dim = hexToRgba(styles_properties.accent_color, 0.15);
    if (dim) cssVars['--kiosk-accent-dim'] = dim;
  }
  if (styles_properties.border_radius != null && styles_properties.border_radius !== '') {
    cssVars['--kiosk-radius'] = `${Number(styles_properties.border_radius) * scaleFactor}px`;
  }
  if (styles_properties.border_radius_sm != null && styles_properties.border_radius_sm !== '') {
    cssVars['--kiosk-radius-sm'] = `${Number(styles_properties.border_radius_sm) * scaleFactor}px`;
  }
  const style = {
    ...cssVars,
    ...extraStyle
  };
  if (styles_properties.font_family) {
    style.fontFamily = styles_properties.font_family;
  }
  return style;
}
const COMMAND_STYLE_DEFAULTS = exports.COMMAND_STYLE_DEFAULTS = {
  background_color: '#0f1419',
  surface_color: '#1a2332',
  card_color: '#232f42',
  accent_color: '#22c55e',
  accent_hover_color: '#16a34a',
  text_color: '#f1f5f9',
  text_muted_color: '#94a3b8',
  border_color: 'rgba(255, 255, 255, 0.08)',
  highlight_color: '#f59e0b',
  border_radius: 16,
  border_radius_sm: 10,
  font_family: "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  payment_provider: 'stripe',
  newcactus_payment_method: 'cash'
};
const COMMAND_STYLE_MODERN_DEFAULTS = exports.COMMAND_STYLE_MODERN_DEFAULTS = {
  background_color: '#f0f4ff',
  surface_color: 'rgba(255, 255, 255, 0.75)',
  card_color: '#ffffff',
  accent_color: '#6366f1',
  accent_hover_color: '#4f46e5',
  text_color: '#0f172a',
  text_muted_color: '#64748b',
  border_color: 'rgba(99, 102, 241, 0.14)',
  highlight_color: '#ec4899',
  border_radius: 24,
  border_radius_sm: 14,
  font_family: "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif"
};
const COMMAND_STYLE_PIZZA_DEFAULTS = exports.COMMAND_STYLE_PIZZA_DEFAULTS = {
  background_color: '#1a0a05',
  surface_color: '#2d1810',
  card_color: '#3d2318',
  accent_color: '#c41e3a',
  accent_hover_color: '#9a1830',
  text_color: '#fff8e7',
  text_muted_color: '#d4c4a8',
  border_color: 'rgba(244, 160, 32, 0.22)',
  highlight_color: '#f4a020',
  border_radius: 12,
  border_radius_sm: 8,
  font_family: "'Playfair Display', 'Georgia', 'Times New Roman', serif"
};
const COMMAND_STYLE_TROPICAL_DEFAULTS = exports.COMMAND_STYLE_TROPICAL_DEFAULTS = {
  background_color: '#e0f7fa',
  surface_color: 'rgba(255, 255, 255, 0.88)',
  card_color: 'rgba(255, 255, 255, 0.95)',
  accent_color: '#00bcd4',
  accent_hover_color: '#0097a7',
  text_color: '#1a4a5e',
  text_muted_color: '#4a7a8c',
  border_color: 'rgba(0, 188, 212, 0.2)',
  highlight_color: '#ff7043',
  border_radius: 20,
  border_radius_sm: 12,
  font_family: "'Quicksand', 'Nunito', 'Poppins', sans-serif"
};
const COMMAND_STYLE_STREET_DEFAULTS = exports.COMMAND_STYLE_STREET_DEFAULTS = {
  background_color: '#1a1a1a',
  surface_color: '#252525',
  card_color: '#2e2e2e',
  accent_color: '#ffc107',
  accent_hover_color: '#ffb300',
  text_color: '#ffffff',
  text_muted_color: '#aaaaaa',
  border_color: 'rgba(255, 193, 7, 0.22)',
  highlight_color: '#e53935',
  border_radius: 8,
  border_radius_sm: 6,
  font_family: "'Bebas Neue', 'Impact', 'Arial Narrow', sans-serif"
};
const COMMAND_STYLE_PATISSERIE_DEFAULTS = exports.COMMAND_STYLE_PATISSERIE_DEFAULTS = {
  background_color: '#faf7f2',
  surface_color: '#fff9f5',
  card_color: '#ffffff',
  accent_color: '#d4a574',
  accent_hover_color: '#c49563',
  text_color: '#3d2b1f',
  text_muted_color: '#8b7355',
  border_color: 'rgba(212, 165, 116, 0.35)',
  highlight_color: '#e8b4b8',
  border_radius: 20,
  border_radius_sm: 12,
  font_family: "'Cormorant Garamond', 'Georgia', serif"
};
const COMMAND_STYLE_PRESTIGE_DEFAULTS = exports.COMMAND_STYLE_PRESTIGE_DEFAULTS = {
  background_color: '#0a0a0a',
  surface_color: '#141414',
  card_color: '#1a1a1a',
  accent_color: '#c9a962',
  accent_hover_color: '#b8944d',
  text_color: '#f5f0e6',
  text_muted_color: '#8a8272',
  border_color: 'rgba(201, 169, 98, 0.28)',
  highlight_color: '#c9a962',
  border_radius: 4,
  border_radius_sm: 2,
  font_family: "'Cormorant', 'Garamond', 'Times New Roman', serif"
};
const COMMAND_STYLE_NEON_DEFAULTS = exports.COMMAND_STYLE_NEON_DEFAULTS = {
  background_color: '#0d0221',
  surface_color: '#1a0533',
  card_color: '#240846',
  accent_color: '#00ffff',
  accent_hover_color: '#00cccc',
  text_color: '#e0e0ff',
  text_muted_color: '#9070c0',
  border_color: 'rgba(0, 255, 255, 0.35)',
  highlight_color: '#ff00ff',
  border_radius: 4,
  border_radius_sm: 2,
  font_family: "'Orbitron', 'Rajdhani', monospace"
};
const COMMAND_STYLE_LATINO_DEFAULTS = exports.COMMAND_STYLE_LATINO_DEFAULTS = {
  background_color: '#1c0c08',
  surface_color: 'rgba(62, 24, 14, 0.9)',
  card_color: '#3a1c14',
  accent_color: '#f25c2a',
  accent_hover_color: '#d44518',
  text_color: '#fff4e6',
  text_muted_color: '#e0b896',
  border_color: 'rgba(246, 196, 69, 0.28)',
  highlight_color: '#f6c445',
  border_radius: 18,
  border_radius_sm: 12,
  font_family: "'Fraunces', 'Nunito', Georgia, serif"
};
const COMMAND_STYLE_DEMO_DEFAULTS = exports.COMMAND_STYLE_DEMO_DEFAULTS = {
  background_color: '#0b1020',
  surface_color: 'rgba(18, 24, 42, 0.72)',
  card_color: 'rgba(28, 36, 58, 0.88)',
  accent_color: '#7c8cff',
  accent_hover_color: '#6366f1',
  text_color: '#f4f6fb',
  text_muted_color: '#9aa3b8',
  border_color: 'rgba(255, 255, 255, 0.12)',
  highlight_color: '#5eead4',
  border_radius: 22,
  border_radius_sm: 14,
  font_family: "'Outfit', 'Manrope', system-ui, sans-serif"
};
const COMMAND_STYLE_MINIMAL_DEFAULTS = exports.COMMAND_STYLE_MINIMAL_DEFAULTS = {
  background_color: '#ffffff',
  surface_color: '#f8f9fa',
  card_color: '#ffffff',
  accent_color: '#2563eb',
  accent_hover_color: '#1d4ed8',
  text_color: '#111827',
  text_muted_color: '#6b7280',
  border_color: '#e5e7eb',
  highlight_color: '#2563eb',
  border_radius: 8,
  border_radius_sm: 6,
  font_family: "system-ui, -apple-system, 'Segoe UI', sans-serif"
};
const TEMPLATE_DEFAULTS = {
  default: COMMAND_STYLE_DEFAULTS,
  modern: COMMAND_STYLE_MODERN_DEFAULTS,
  pizza: COMMAND_STYLE_PIZZA_DEFAULTS,
  tropical: COMMAND_STYLE_TROPICAL_DEFAULTS,
  street: COMMAND_STYLE_STREET_DEFAULTS,
  patisserie: COMMAND_STYLE_PATISSERIE_DEFAULTS,
  prestige: COMMAND_STYLE_PRESTIGE_DEFAULTS,
  neon: COMMAND_STYLE_NEON_DEFAULTS,
  minimal: COMMAND_STYLE_MINIMAL_DEFAULTS,
  demo: COMMAND_STYLE_DEMO_DEFAULTS,
  latino: COMMAND_STYLE_LATINO_DEFAULTS
};
function mergeCommandStyles(templateVariant = 'default', styles_properties = {}) {
  const base = TEMPLATE_DEFAULTS[templateVariant] ?? COMMAND_STYLE_DEFAULTS;
  return {
    ...base,
    ...styles_properties
  };
}
function getTemplateStyleDefaults(templateVariant = 'default') {
  return TEMPLATE_DEFAULTS[templateVariant] ?? COMMAND_STYLE_DEFAULTS;
}